<template>
  <el-tooltip v-if="isOverflowing" :content="text" placement="top">
    <span ref="textRef" class="ellipsis-text">{{ text }}</span>
  </el-tooltip>
  <span v-else ref="textRef" class="ellipsis-text">{{ text }}</span>
</template>

<script setup>
import { ref, onMounted, defineProps, watch, nextTick } from "vue";

const props = defineProps({ text: String });

const textRef = ref(null);
const isOverflowing = ref(false);

const checkOverflow = () => {
  const el = textRef.value;
  if (el) isOverflowing.value = el.scrollWidth > el.clientWidth;
};

onMounted(() => nextTick(checkOverflow));
watch(
  () => props.text,
  () => nextTick(checkOverflow)
);
</script>

<style scoped>
.ellipsis-text {
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
